import {
  KanalType,
  KundgruppType,
  LamnaOverType,
} from "@/composables/KundserviceAppApiClient";
import type { Option, OptionGroup } from "@/types/form";
import {
  kanalTypeToOption,
  kundgruppTypeToOption,
  lamnaOverTypeToOption,
} from "@/common/constants";

export const UnlinkedKanalOptions: Option[] = [
  KanalType.Telefon,
  KanalType.Chat,
  KanalType.Epost,
  KanalType.InloggadPaAvtalatSe,
].map(kanalTypeToOption);

export const UnlinkedKundgruppOptions: Option[] = [
  KundgruppType.Arbetare,
  KundgruppType.Arbetsgivare,
  KundgruppType.Tjansteman,
  KundgruppType.Arbetsgivarforbund,
  KundgruppType.Fackforbund,
  KundgruppType.Partsbolag,
  KundgruppType.Forsakringsinformator,
].map(kundgruppTypeToOption);

export const UnlinkedLamnaOverTillOptionGroups: OptionGroup[] = [
  {
    label: "Andra tjänster",
    options: [
      lamnaOverTypeToOption(LamnaOverType.Radgivningstjansten),
      lamnaOverTypeToOption(LamnaOverType.SupportForInformatorer),
      lamnaOverTypeToOption(LamnaOverType.Webbgruppen),
      lamnaOverTypeToOption(LamnaOverType.Klagomal),
      lamnaOverTypeToOption(LamnaOverType.Legal),
    ],
  },
  {
    label: "Externt",
    options: [
      lamnaOverTypeToOption(LamnaOverType.Fora),
      lamnaOverTypeToOption(LamnaOverType.Alecta),
      lamnaOverTypeToOption(LamnaOverType.AfaForsakring),
      lamnaOverTypeToOption(LamnaOverType.CollectumForetag),
    ],
  },
];
